<template>
	<div>
    <li>
      <a href="javascript:;">
          <i class="icon ion-home"></i>Home
      </a>
    </li>   
    <li v-for="(item, idx) in breadCrumbList"  class="active" :key="idx" @click="routeTo(idx)">
      <router-link :to="item.path">
        {{ item.name }}
      </router-link>
    </li>
	</div>
</template>

<script>
export default {
  name: 'Breadcrumb',
  data: function() {
    return {
      breadCrumbList: []
    }
  },
  mounted() {
    this.updateList()
  },
  watch: {
    '$route'() {
      this.updateList()
    }
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadCrumbList[pRouteTo].link) {
        this.$router.push(this.breadCrumbList[pRouteTo].link)
      }
    },
    updateList() {
      this.breadCrumbList = this.$route.meta.breadcrumb
    }
  }
}
</script>



// WEBPACK FOOTER //
// Breadcrumb.vue?2708eef7